import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'hpf-video',
  templateUrl: './video.component.html'
})
export class VideoComponent implements OnInit {

  /** Constructor */
  constructor() {}

  /** Init */
  ngOnInit() {}

}
